import { j as r } from "./kezios-design-system.esm172.js";
import { Stack as t, Avatar as l, Text as e, Rating as m } from "@mantine/core";
import a from "./kezios-design-system.esm208.js";
import { Spacing as s } from "./kezios-design-system.esm135.js";
const v = ({
  avatarSrc: c,
  content: i,
  name: n,
  rating: o,
  ...x
}) => /* @__PURE__ */ r.jsxs(t, { maw: 400, gap: s.s2, align: "center", ...x, children: [
  /* @__PURE__ */ r.jsx(l, { src: c }),
  /* @__PURE__ */ r.jsxs(t, { gap: s.s1, align: "center", children: [
    /* @__PURE__ */ r.jsx(e, { className: a.text, variant: "textMd", c: "gray.6", children: i }),
    /* @__PURE__ */ r.jsx(e, { className: a.text, variant: "textSm", c: "gray.6", children: n })
  ] }),
  /* @__PURE__ */ r.jsx(m, { color: "yellow.3", value: o, readOnly: !0 })
] });
export {
  v as Review
};
